import React, { useEffect } from "react";
import { FIND_LISTINGS_WITH_SOV } from "@/graphql/queries/find.listings";
import { useQuery } from "@apollo/client";
import ListingCard from "@/components/Listing/ListingCard";
import styles from "./suggestedList.module.scss";
import {
  listingToEECItemObject,
  trackSelectItem,
  trackViewItemList,
} from "@/lib/tracking/trackEECEvents";
import { usePath } from "@/contexts/path/path";

const SuggestedListings = ({ categoryId, cityId }) => {
  const listingListRef = React.useRef(null);
  const { data, loading, error } = useQuery(FIND_LISTINGS_WITH_SOV, {
    variables: {
      size: 20,
      from: 0,
      sort: {
        create_time: "desc",
        has_img: "desc",
      },
      where: {
        category: {
          eq: categoryId,
        },
        city_id: {
          eq: cityId,
        },
      },
      sov: {
        listing_category: categoryId,
        city_id: cityId,
        enabled: true,
        campaign_category: "PROMOTED",
      },
    },
  });

  const { harajRNPLData, previousPath } = usePath();
  const fullCategory = harajRNPLData?.fullCategory;

  useEffect(() => {
    const el = listingListRef.current;
    if (!el) return;
    const onWheel = (e) => {
      if (e.deltaY !== 0) {
        el.scrollLeft += -e.deltaY;
        e.preventDefault();
      }
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, [listingListRef.current]);

  const suggestedList = data?.Web?.sov?.listings?.length
    ? data?.Web?.sov?.listings
    : data?.Web?.find?.listings;

  useEffect(() => {
    if (!!suggestedList?.length) {
      trackViewItemList({
        itemListName: fullCategory?.ga_listing_type,
        listingType: fullCategory?.ga_listing_type,
        category: fullCategory?.ga_property_category,
        count: suggestedList.length,
        listings: suggestedList.map((listing, index) =>
          listingToEECItemObject(listing, index, { categoryId: fullCategory }),
        ),
        journey_details: "rent_now_pay_later_haraj",
      });
    }
  }, [suggestedList]);

  if (loading || error) return null;

  const trackSelectListing = (listing) => {
    trackSelectItem({
      itemListName: fullCategory?.ga_listing_type,
      listingType: fullCategory?.ga_listing_type,
      category: fullCategory?.en,
      count: suggestedList.length,
      listings: [suggestedList].map((listing, index) =>
        listingToEECItemObject(listing, index, { categoryId: fullCategory }),
      ),
      journey_details: "rent_now_pay_later_haraj",
    });
  };

  return (
    <div ref={listingListRef} className={styles.list}>
      {suggestedList?.map((listing, index) => (
        <ListingCard
          key={listing.id}
          listing={listing}
          index={index}
          imageClass={styles.paddedImage}
          trackClickEvent={trackSelectListing}
          horizontal
        />
      ))}
    </div>
  );
};

export default SuggestedListings;
